import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=b57622c8&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57622c8')) {
      api.createRecord('b57622c8', component.options)
    } else {
      api.reload('b57622c8', component.options)
    }
    module.hot.accept("./Teaser.vue?vue&type=template&id=b57622c8&", function () {
      api.rerender('b57622c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/Teaser.vue"
export default component.exports